import { RealEstate } from '../real-estate';
import { RealEstateService } from '../real-estate.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';

@Component({
	selector: 'app-realEstate',
	templateUrl: './real-estate.component.html',
	styleUrls: ['./real-estate.component.css'],
	providers: [MessageService, ConfirmationService],
	standalone: false
})
export class RealEstateComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private realEstateService: RealEstateService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.realEstate = data.realEstate,
			this.statuses = realEstateService.statuses;
	}

	@Input() realEstate: RealEstate;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	realEstateId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'realEstateId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [],
		'realEstateDate': [],
		'isRealEstate': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole realEstate object
		if (this.realEstate) {
			this.realEstateId = this.realEstate.realEstateId;
			this.fixDates();
			this.form1.patchValue(this.realEstate);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.realEstateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.realEstateService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.realEstate = res.data.realEstate;
						this.doAdd.emit(this.realEstate);
					},
					(err: any) => {
						console.log('realEstate-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('realEstate: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.realEstateService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.realEstate = res.data.realEstate;
						this.doUpdate.emit(this.realEstate);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.realEstateService.delete(this.realEstate.realEstateId)
				.subscribe(
					(res: any) => {
						console.log('realEstate-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.realEstate);
					},
					(err: any) => {
						console.log('realEstate-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			realEstateId: [this.realEstateId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			status: [],
			realEstateDate: [],
			isRealEstate: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.realEstate.realEstateDate = moment(this.realEstate.realEstateDate).toDate();
	}
}
